import { axios, exportAction } from '@/libs/api.request';
import { Response } from '@/types/request.d';
import i18n from '@/locales';
import { TaskListItem } from '@/api/sys/project/jobTask';
import { localRead } from '@/libs/util';

export interface SessionListParams {
    page: number;
    page_size: number;
    snippet_time: string;
    type: '1' | '2' | '-1'; // 会话列表类型 1-未分配 2-已分配, -1 机器人接管
    last_ids: string;
    keyword?: string; // 搜索字段
    chat_user_id?: string; // 搜索字段
    assign_sys_user_id?: string; // 客服sys_user_id
    filter_type: '0' | '1'; // 0-全部（默认 ）1-未读
    channel_list?: string;
    phone?: string;
    label_ids?: string;
    label_ids_condition?: string;
    status?: 'active' | 'inactive';// 会话状态（active 进行中，inactive 睡眠中）
}
export interface SessionItem {
    id: string;
    project_id: string;
    chat_user_id: string;
    chat_session_id: string;
    channel_id: string;
    channel: Chat.channel;
    channel_name: string;
    title: string;
    avatar: string;
    snippet: string;
    snippet_type: '0' | '1' | '2' | '3'; // 最后一条内容类型（0 接收，1 发送-人工回复，2 机器人回复，3 最后一条消息发送失败）
    snippet_time: string;
    is_read: '0' | '1'; // 是否已读（0 未读，1 已读）
    is_online: '0' | '1';// 在线1, 离线 0
    robot_reply: '0' | '1';// 机器人托管 1开启,  0 关闭
    is_ai_employee_assign?: '0' | '1';
    sys_user_id: string; //  指派人的 id， 未指派为 '0'、机器人为 '-1'
    tags: string;
    remark: string;
    remark_name: string;
    type: '1' | '2' | '3' | '4' | '5'; // 1单聊会话、2群、3超级群（暂不使用）、4频道 、5社群
    is_reply: '0' | '1'; // 会话额度限制 0 禁止回复 1 允许回复
    pin_time: string; // 置顶时间
    last_reply_time: string;
    calcTime?: number; // 用于在线聊天计算已超时的时间-自定义
    user_last_reply_time: string;
    unread_count: number; // 未读消息数
    labels: { id: string; label_name: string }[];
    nickname?: string; // 接待客服名称
    sender_name?: string;
    auto_translate: '0' | '1';
    receive_translate: '0' | '1';
    send_translate: '0' | '1';
    auto_translate_lang: string;
    send_translate_lang: string;
    translation_preview: '0' | '1'; // 翻译预览 1-开启 0-关闭
    chat_session_code: string;
    phone: string;
    email: string;
    is_disturb: string; // 0 非消息免打扰状态 1 消息免打扰状态
    snippet_msg_type: string; // 判断系统消息
    created_time: string; // 会话创建时间，秒级时间戳
}
export interface SessionListRes {
    list: SessionItem[];
    page: string;
    page_size: string;
}
/**
 * 获取会话列表
 */
export const getSessionList = (params: SessionListParams) => axios.request<Response<SessionListRes>>({
    url: '/chat/chat-user/get-session-list',
    method: 'get',
    params,
    // mock: true,
});

interface SessionCountParams {
    type: '1' | '2' | '-1'; // 会话列表类型 1-未分配 2-已分配, -1 机器人接管
    keyword?: string; // 搜索字段
    chat_user_id?: string; // 搜索字段
    assign_sys_user_id?: string; // 客服sys_user_id
    filter_type: '0' | '1'; // 0-全部（默认 ）1-未读
    channel?: string;
}
interface SessionCountRes {
    total: string;
}

interface checkCanGetSessionCountRes {
    count: string;
    limit: string;
    bucket: string;
    is_pass: '0' | '1'; // 1-通过 0-不通过
}

/**
 * 获取会话列表总数
 */
export const getSessionCount = (params: SessionCountParams) => axios.request<Response<SessionCountRes>>({
    url: '/chat/chat-user/get-session-count',
    method: 'get',
    params,
    // mock: true,
});

/**
 * 判断是否可以获取会话未读数
 */
export const checkCanGetSessionCount = () => axios.request<Response<checkCanGetSessionCountRes>>({
    url: '/chat/chat-user/check-session-limit',
    method: 'get',
    params: {},
    customTips: true,
});

export type MessageListParams = {
    chat_user_id: string;
    sequence_id: string;
    end_sequence_id?: string;
    direction_type?: '0' | '1'; // 0-默认 逆向查询 1-正向查询
    page_size?: number;
    is_history?: '0' | '1'; // 查询顺序，默认 0 逆序查，1 顺序查
};
export type MessageItem = Chat.MessageItem;
interface MessageListRes {
    list: MessageItem[];
    next_pk: {
        chat_user_id: string;
        sequence_id: string;
    };
    page: string;
    page_size: string;
    package_limit: string; // 是否达到套餐限制，比如说基础版只能看最近60天数据
}
/**
 * 获取用户聊天记录
 */
export const getMessageList = (params: MessageListParams) => axios.request<Response<MessageListRes>>({
    url: '/chat/chat-user/get-message-list',
    method: 'get',
    params,
    // mock: true,
});

interface UserInfoParams {
    chat_user_id: string;
}
export interface MessengerInfo {
    ad_referral: {
        ad_id: string;
        ad_photo_url: string;
        ad_video_url: string;
        ad_title: string;
        post_id: string;
        source: string;
    };
    avatar: string;
    fb_id: string;
    gender: string;
    is_guest: '0' | '1';
    locale: string;
    migrate_id: string;
    profile_pic: string;
    psid: string;
    psid_status: '0' | '1';
    timezone: string;
    user_ref: string;
    user_type: string;
}
export interface WhatsappInfo {
    ad_referral: {
        ad_id: string;
        ad_photo_url: string;
        ad_video_url: string;
        ad_title: string;
        post_id: string;
        source: string;
        ad_link?: string;
    };
    [key: string]: any;
}
export interface EmailInfo {
    email: string;
    name: string;
    content: string;
    gender?: string;
}
export interface PluginInfo {
    content:{
        phone: string;
        email: string;
        description: string;
    };
    country: string;
    ip: string;
    language: string;
    gender: string;
    name: string;
    source_url: string;
    last_source_url: string;
    token_expired_time: string;
    ua: string;
    user_id: string;
    user_type: string;
    before_source_url?:string // 聊天插件最初访问来源
}

/** 聊天插件输入限制原因，由后端合规策略统一计算。 */
export type ChatComplianceRestrictionType = 'none' | 'ip_risk' | 'contact_risk' | 'high_risk';

/** 聊天插件合规状态；渠道 2 的输入框只按该字段决定是否限制。 */
export interface ChatComplianceInfo {
    input_restricted: '0' | '1';
    restriction_type: ChatComplianceRestrictionType;
}

interface UserInfoBase {
    chat_user_id: string;
    project_id: string;
    channel: Chat.channel;
    channel_id: string; // 渠道id
    channel_name: string; // 渠道名
    channel_uid: string; // 渠道用户标识
    name: string; // 姓名
    avatar: string; // 头像
    email: string; // 联系邮箱
    country: string; // 城市
    city: string; // 城市
    created_time: string;
    custom_fields?: { // 自定义字段内容
        [key: string]: string | string[];
    };
    language: string; // 语言 --- 已废弃！！！
    translate_language: string; // 替换原先的语言字段 —— 客户信息语言、翻译语言字段合并优化
    is_online: '1' | '0'; // 是否在线 1-是 0-否
    remark: string; // 备注
    phone: string;
    area_code: string; // 区号
    phone_number?: string; // 电话号码
    last_send_time: string; // 用户最后发送时间，用于超时判断
    robot_reply: '0' | '1';
    auto_translate: '0' | '1'; // 翻译总开关
    receive_translate: '0' | '1'; // 接收到的消息是否翻译
    send_translate: '0' | '1'; // 发送的消息是否翻译
    translate_way: string; // 翻译线路对应的编码
    auto_translate_lang: string;
    send_translate_lang: string;
    translation_preview: '0' | '1'; // 翻译预览 1-开启 0-关闭
    labels: {
        id: string;
        label_name: string;
    }[]; // 标签
    channel_avatar: string; // 渠道头像
    is_black: '0' | '1'; // 是否黑名单
    channel_status: '0' | '1';// 插件是否有效（删除） 1有效,  0 删除/关闭
    channel_auth_status: '0' | '1'; // 该账号已被移出工作区，无法聊天  1有效,  0 移出
    remark_name: string;
    is_del: '0' | '1'; // 是否已删除（0 未删除， 1已删除）
    sys_user_id: string;
    nickname?: string;
    chat_session_code: string;
    shop_id?: string;
    channel_config: {
        remark?: string; // 渠道备注
        whatsapp_phone?: string;
        bot_url?:string
        weixin_id?: string;
    };
    channel_info?: any;
    channel_is_del?: '0' | '1'; // 渠道是否已删除（0 未删除， 1已删除）
    chat_type?: string; // 会话类型 '1' | '2' | '5'
    isRemotely?: '0' | '1'; // 是否已加载远程数据
    server_timestamp: string; // 服务器时间
    free_expiration_timestamp?: string; // WhatsApp API 免费消息窗口到期时间（Unix 秒）
    is_allow_reply: '0' | '1'; // 会话数是否达到限制
    channel_username: string; // 账号ID
    messenger_topics: {
        id: string;
        topic_name: string;
    }[]; // Messengr订阅
    email_translate_way: string; // ai翻译，邮箱翻译线路
    session_created_time?: string; // 会话创建时间
    ai_detect_lang?: string; // ai识别语言
    is_manual_translate_lang?: '0' | '1'; // 是否手动翻译语言 1-是 0-否
    // 是否被禁言 1是, 其他都是否
    is_group_banned_post?: '1';
}
export interface MessengerUserInfo extends UserInfoBase {
    channel: '1' | '8';
    channel_info: MessengerInfo; // 渠道信息对象
    channel_status: '0' | '1';// 插件是否有效（删除） 1有效,  0 删除/关闭
}
export interface WhatsAppUserInfo extends UserInfoBase {
    channel: '7';
    channel_info: WhatsappInfo; // 渠道信息对象
    chat_type?: any;
    channel_status: '0' | '1';// 插件是否有效（删除） 1有效,  0 删除/关闭
    channel_config: {
        remark?: string;
        whatsapp_type: '0' | '1' | '2'; // 0 商业API号、1 平台号、2 cloud api号
        whatsapp_channel: Chat.whatsappChannel;
        whatsapp_phone?: string; // 电话号码
    };
}
export interface PluginUserInfo extends UserInfoBase {
    channel: '2' | '9';
    channel_info: PluginInfo; // 渠道信息对象
    channel_status: '0' | '1';// 插件是否有效（删除） 1有效,  0 删除/关闭
    shop_id: string; // 所在的店铺ID
    /** 新旧服务灰度期间可能缺失；缺失时不主动限制输入。 */
    chat_compliance?: ChatComplianceInfo;
}
export interface EmailUserInfo extends UserInfoBase {
    channel: '2' | '3';
    channel_info: EmailInfo; // 渠道信息对象
    channel_config: {
        remark?: string;
        address: string;
        signature: string;
        sender_name: string;
    };
    channel_status: '0' | '1';// 插件是否有效（删除） 1有效,  0 删除/关闭
}
export interface ChannelUserInfo extends UserInfoBase {
    channel: '4' | '5' | '6' | '13' | '15';
    channel_info: any; // 渠道信息对象
    channel_status: '0' | '1';// 插件是否有效（删除） 1有效,  0 删除/关闭
}
export interface SlackUserInfo extends UserInfoBase {
    channel: '10';
    channel_info: any; // 渠道信息对象
    channel_in_group_status: '0' | '1';// 判断用户是否在群组里 1在群聊里 0否
}

export interface WeixinUserInfo extends UserInfoBase {
    channel: '11';
    channel_info: any; // 渠道信息对象
    channel_status: '0' | '1';// 是否有效
}

export interface IndividualWhatsappUserInfo extends UserInfoBase {
    channel: '12';
    channel_info: any; // 渠道信息对象
    channel_status: '0' | '1';// 是否有效
    chat_type: string; // 群类型
    channel_config: {
        remark?: string;
        type: '1' | '2';
        whatsapp_phone?: string; // 电话号码
    };
}

export interface WecomUserInfo extends UserInfoBase {
    channel: '14',
    channel_info: any; // 渠道信息对象
    channel_config: {
        remark: string;
        weixin_id: string;
    }
}

export interface TikTokAppUserInfo extends UserInfoBase {
    channel: '16',
    channel_info: Record<string, any>; // 渠道信息对象
}

export interface TikTokCommentUserInfo extends UserInfoBase {
    channel: '17',
    channel_info: any; // 渠道信息对象
}

export interface VKontakteUserInfo extends UserInfoBase {
    channel: '18',
    channel_info: any; // 渠道信息对象
}
export interface ZaloUserInfo extends UserInfoBase {
    channel: '19',
    channel_info: any; // 渠道信息对象
    channel_status: '0' | '1'; // 插件是否有效（删除） 1有效, 0删除/关闭
}
export interface TikTokBusinessUserInfo extends UserInfoBase {
    channel: '20' | '21',
    channel_info: any; // 渠道信息对象
}

export interface YoutubeUserInfo extends UserInfoBase {
    channel: '22',
    channel_info: any; // 渠道信息对象
}

export type UserInfo = MessengerUserInfo | PluginUserInfo | EmailUserInfo | ChannelUserInfo | SlackUserInfo | WhatsAppUserInfo | WeixinUserInfo | IndividualWhatsappUserInfo | WecomUserInfo | TikTokAppUserInfo | TikTokCommentUserInfo | VKontakteUserInfo | ZaloUserInfo | TikTokBusinessUserInfo | YoutubeUserInfo;
/**
 * 获取用户聊天记录
 */
export const getUserInfo = (params: UserInfoParams) => axios.request<Response<UserInfo>>({
    url: '/chat/chat-user/get-user-info',
    method: 'get',
    params,
    cancelDuplicateRequest: true,
    // mock: true,
});

/**
 * 更新客户资料时用于区分操作日志来源的菜单模块。
 * 7：在线聊天；8：客户板块下的会话管理。
 */
export type UpdateUserInfoMenuModule = 7 | 8;

/** 更新客户资料接口参数。 */
export interface UpdateUserInfoParams {
    chat_user_id: string;
    labels?: string;
    remark?: string;
    is_black?: '0' | '1'; // 是否拉黑（0 取消拉黑，1 拉黑）
    module?: 'chat_online_list' | 'contact_list' | 'session_list';
    /** 操作日志归属模块；不传时后端按聊天模块处理。 */
    menu_module?: UpdateUserInfoMenuModule;
    remark_name?: string;
    phone?: string;
    email?: string;
    area_code?: string;
    phone_number?: string;
    custom_fields?: string;
    country?: string; // 所在国家
    city?: string; // 所在地区

    translate_language?: string; // 访客语言
    is_ai_detect?: '0' | '1'; // 是否是AI识别语言
}
/**
 * 更新用户信息
 */
export const updateUserInfo = (params: UpdateUserInfoParams) => axios.request({
    url: '/chat/chat-user/update-user-info',
    method: 'post',
    data: params,
    // mock: true,
});

/**
 * 批量拉黑
 */
export const batchBlackInfoTask = (params: any) => axios.request<Response<any>>({
    url: '/chat/chat-user/batch-update-black-task',
    method: 'post',
    data: params,
    // mock: true,
});

export interface EndSessionParams {
    session_id: string;
    chat_user_id: string;
    remark?: string;
    tags?: string;
    session_status?: 'active' | 'inactive';
    invite_evalution?: string;
}
/**
 * 结束会话
 */
export const endSession = (params: EndSessionParams) => axios.request({
    url: '/chat/chat-user/end-session',
    method: 'post',
    data: params,
    // mock: true,
});

export interface UpdateSessionInfoParams {
    session_id: string;
    chat_user_id: string;
    tags: string;
    remark: string;
    session_status?: 'active' | 'inactive' | 'storage';
    /** 操作日志归属模块；在线聊天使用 7，会话管理使用 8。 */
    menu_module?: UpdateUserInfoMenuModule;
}
/**
 * 更新会话信息
 */
export const updateSessionInfo = (data: UpdateSessionInfoParams) => axios.request({
    url: '/chat/chat-user/update-session-info',
    method: 'post',
    data,
});

interface SendMessageParamsBase {
    room_type: '6'; // 推送房间类型
    msg_type: Chat.msgType; // 消息类型
    chat_user_id: string;
    retry_id?: string; // 发送失败重试发送的原 sequence_id
    quote_chat?: string; // 引用消息体
    source_content?: string; // 原文，翻译消息时使用
    tag?: string; // messenger、Instagram 标签
    email_id?: string; // 邮件消息 msg_type(7), 非 Email 渠道必填
    sys_variables?: string; // WhatsApp 模版消息变量
    original_send?: '1' | '0'; // 是否原文发送
    client_expand_info?: any; // 客户端扩展信息
}

export interface SendTextMessageParams extends SendMessageParamsBase {
    msg_type: '1';
    message: string;
}
export interface SendMediaMessageParams extends SendMessageParamsBase {
    msg_type: '2' | '4' | '6' | '12';
    message: string | any;
}
export interface SendTemplateMessageParams extends SendMessageParamsBase {
    msg_type: '3';
    message: any;
}
export interface SendPostBackMessageParams extends SendMessageParamsBase {
    msg_type: '5';
    message: {
        postback: string;
        text: string;
    };
}
export interface SendEmailMessageParams extends SendMessageParamsBase {
    msg_type: '7';
    email_id: string;
    variable_config?: string;
    message: {
        title: string;
        content: string;
        attachments: string;
    };
}
export interface SendSysMsgParams extends SendMessageParamsBase {
    msg_type: '8';
    message: {};
}
export interface SendAIMessageParams extends SendMessageParamsBase {
    msg_type: '11';
    message: {};
}
export interface SendCommentMessageParams extends SendMessageParamsBase {
    msg_type: '13';
    message: {};
}

export interface SendProductMessageParams extends SendMessageParamsBase {
    msg_type: '14';
    message: {
        type: string; // product_card
        product_info: {
            product_id: string;
            currency_code: string;
            purchase_address: string;
            product_picture: string;
            product_name: string;
            price: string;
            original_price: string;
        };
    };
}

export interface SendSurveyParams extends SendMessageParamsBase {
    msg_type: '19';
}
export interface SendAiteMessageParams extends SendMessageParamsBase {
    msg_type: '20';
    message: any;
}

export interface OtherMessageParams extends SendMessageParamsBase {
    msg_type: Chat.msgType;
    message: any;
}

export interface SendGroupRemoveMenbers extends SendMessageParamsBase {
    msg_type: '37';
    message: {
        type: 'remove';
        participant_jid: string;
    };
}

export type SendMessageParams = SendTextMessageParams
    | SendTemplateMessageParams
    | SendMediaMessageParams
    | SendPostBackMessageParams
    | SendEmailMessageParams
    | SendSysMsgParams
    | SendAIMessageParams
    | SendCommentMessageParams
    | SendProductMessageParams
    | SendAiteMessageParams
    | SendSurveyParams
    | SendGroupRemoveMenbers
    | OtherMessageParams;

interface ReceiveMessageBase {
    chat_user_id: string;
    sequence_id: string;
    sender_type: string;
    sender: string;
    sender_name: string;
    send_time: string;
}

export interface SendMessageRes {
    data: Chat.ReceiveTextMessage | Chat.ReceiveMediaMessage | Chat.ReceiveTemplateMessage | Chat.ReceivePostbackMessage | Chat.ReceiveEmailMessage | Chat.ReceiveSysMsgMessage;
    code: number;
    msg: string;
}

interface UserListParams {
    page: string;
    page_size: string;
    channel?: string;
    name?: string;
    email?: string;
    tags?: string;
    country?: string;
    city?: string;
    language?: string;
    status?: string;
}
export interface ChatUserListItem {
    channel: string;
    city: string;
    country: string;
    created_time: string;
    email: string;
    language: string;
    name: string;
    phone: string;
    status: string;
    chat_user_id: string;
    channel_info?: string;
    channel_id?: string;
    channel_name: string;
    channel_phone: string;
    type?: string;
    chat_type: string;
    avatar: string;
    channel_uid: string;
    labels?: { id: string; label_name: string }[];
}
interface UserListRes {
    list: ChatUserListItem[];
    page: string;
    page_size: string;
    total: number;
}
/**
 * 获取联系人列表
 */
export const getChatUserList = (params: UserListParams) => axios.request<Response<UserListRes>>({
    url: '/chat/chat-user/get-chat-user-list',
    method: 'get',
    params,
    // mock: true,
});

interface ContactListParams {
    page: string;
    page_size: string;
    type: 'all_user ' | 'valid_user'; // 客户类型（全部客户：all_user ， 有效客户：vaild_user）
    channel?: string;
    module?: 'message_broadcast' | 'message_broadcast_sms' | 'edm_broadcast';
    country?: string;
    city?: string;
    language?: string;
    is_online?: 0 | 1;
    create_time?: string; // {"start": 1638288000, "end": 1638892800}
    query?: string; // 复合查询结构 [{"field":"phone","condition":"empty","value":""}]
    search_type?: '0' | '1', // 搜索条件类型 0-默认 1-自定义字段
    user_type?: string;
    group_type?: string;
    content_type?:string; // 针对whatsapp api群发消息筛选受众
    is_group_auth?: '0' | '1', // 是否开启新成员分组模式鉴权：1.开启， 0.不开启
}

/**
 * 获取联系人列表(新)
 */
export const getContactList = (data: ContactListParams) => axios.request<Response<UserListRes>>({
    url: '/chat/chat-user/get-contact-list',
    method: 'post',
    data,
    // mock: true,
});

/**
 * 获取联系人列表 (去除我的客户、有效客户)
 */
export const getContactListV1 = (data: ContactListParams) => axios.request<Response<UserListRes>>({
    url: '/chat/chat-user/get-contact-list-v1',
    method: 'post',
    data,
});

/**
 * 创建会话
 */
export const createSession = (data: { chat_user_id: string }) => axios.request<Response<{ session_status: 'active' | 'inactive' }>>({
    url: '/chat/chat-user/create-session',
    method: 'post',
    data,
    customTips: true,
});

/**
 * 创建会话
 */
export const batchCreateSession = (data: { chat_user_ids: string }) => axios.request<Response<{ session_status: 'active' | 'inactive' }>>({
    url: '/chat/chat-user/batch-create-session',
    method: 'post',
    data,
    customTips: true,
});

/**
 * 获取会话信息
 */
export const getSessionInfo = (params: { chat_user_id: string }) => axios.request<Response<SessionItem>>({
    url: '/chat/chat-user/get-session-info',
    method: 'get',
    params,
});

export interface ReassignSessionParams {
    session_id: string;
    chat_user_id: string;
    assign_sys_user_id: string;
    session_status?: 'active' | 'inactive' | 'storage';

    type?: '-1' | '1' | '2'; // 2 已分配、1 未分配、-1 机器人
}
/**
 * 重新分配会话
 */
export const reassignSession = (params: ReassignSessionParams) => axios.request({
    url: '/chat/chat-user/reassign-session',
    method: 'post',
    data: params,
});

export interface ChnannelStatus {
    is_reauthorization: string; // 是否有权限不足的主页（0 无，1 有）
    is_instagram_reauthorization: string; // 是否有instagram权限不足的主页（0 无，1 有）
    is_telegram_reauthorization: string; // 是否有telegram token 失效（0 无，1 有）
    is_reactive: string; // 是否有状态为异常的邮箱（0 无，1 有）
    is_line_reauthorization: string; // 是否有 line token 失效（0 无，1 有）
    is_whatsapp_reauthorization: string; // 是否有 whatsapp token 失效（0 无，1 有）
    is_comment_reauthorization: string; // 主页评论是否需要重新授权（0 无，1 是）
    is_slack_reauthorization: string; // slack 账号是否失效（0 无，1 是）
    is_individual_whatsapp_reauthorization: string; // whatsapp个号 是否失效（0 无，1 是）
    is_workweixin_reauthorization: string; // 企业微信账号状态 （0 无，1 是）
}

/**
 * 检查渠道配置状态
 */
export const checkChannelStatus = () => axios.request<Response<ChnannelStatus>>({
    url: '/chat/chat-user/check-channel-status',
    method: 'get',
});

/**
 * 导出记录
 */
export const exportChatUserList = (params: any) => {
    params.lang = localRead('local') || 'zh-CN';
    return exportAction({
        url: 'chat/chat-user/export-chat-user-list',
        method: 'post',
        params,
    });
};

/**
 * 导出记录 (新)
 */
export const exportContactList = (params: any) => {
    params.lang = ['zh-CN', 'zh-TW'].includes(i18n.locale) ? 'zh-CN' : (i18n.locale || 'zh-CN');
    return exportAction({
        url: 'chat/chat-user/export-contact-list',
        method: 'post',
        params,
    });
};

interface UpdateAutoReplyParams {
    session_status?: 'active' | 'inactive';
    session_id: string;
    status: '0' | '1'; // 0 关闭 1开启
}
/**
 * 会话机器人托管开关
 */
export const updateAutoReply = (data: UpdateAutoReplyParams) => axios.request({
    url: '/chat/chat-user/update-auto-reply',
    method: 'post',
    data,
});

export interface UpdateTranslateParams {
    auto_translate?: '0' | '1'; // 翻译总开关 1-开启 0-关闭
    receive_translate?: '0' | '1'; // 翻译接收的消息 1-开启 0-关闭
    auto_translate_lang?: string;
    send_translate?: '0' | '1'; // 发送翻译 1-开启 0-关闭
    send_translate_lang?: string;
    session_id: string;
    session_status?: 'active' | 'inactive';
    is_manual_translate_lang?:'0' | '1';
    chat_user_id?: string;
    translation_preview?: '0' | '1'; // 翻译预览 1-开启 0-关闭
}
/**
 * 更新会话翻译设置
 */
export const updateTranslate = <T>(data: UpdateTranslateParams) => axios.request<Response<T>>({
    url: '/chat/chat-user/update-translate',
    method: 'post',
    data,
});
interface BatchSendMessageParams {
    type: 'all_user ' | 'vaild_user'; // 客户类型（全部客户：all_user ， 有效客户：vaild_user）
    channel?: string;
    country?: string;
    city?: string;
    language?: string;
    is_online?: 0 | 1;
    create_time?: string; // {"start": 1638288000, "end": 1638892800}
    query?: string; // 复合查询结构 [{"field":"phone","condition":"empty","value":""}]
    label_ids: string;
    update_label_ids: string;
    exclude_chat_user_ids: string;
    message_list: string;
    tag: string;
    user_ids?: string; // 接待人
    batch_type?: 'auto_flow_message' | ''; // auto_flow_message - 流程消息， 普通消息默认穿空
    flow_id?: string;
}

// 批量发送信息
export const batchSendMessage = (data: BatchSendMessageParams) => axios.request<Response<{ task_id: string;}>>({
    url: '/chat/chat-user/group-send-message',
    method: 'post',
    data,
});

interface UpdateLabelParams {
    page: string;
    page_size: string;
    type: 'all_user ' | 'vaild_user'; // 客户类型（全部客户：all_user ， 有效客户：vaild_user）
    channel?: string;
    country?: string;
    city?: string;
    language?: string;
    is_online?: 0 | 1;
    create_time?: string; // {"start": 1638288000, "end": 1638892800}
    query?: string; // 复合查询结构 [{"field":"phone","condition":"empty","value":""}]
    label_ids: string;
    ids: string;
    update_type: string;
    action: string;
    update_label_ids: string;
    exclude_chat_user_ids: string;
    task_id?: string;
}

/**
 * 更新标签
 */
export const batchUpdateLabel = (params: UpdateLabelParams) => axios.request<Response<{ task_id: string;}>>({
    url: '/chat/chat-user/batch-update-label',
    method: 'post',
    data: params,
    // mock: true,
});

export interface ContactCountParams {
    page: string;
    page_size: string;
    type: 'all_user ' | 'vaild_user'; // 客户类型（全部客户：all_user ， 有效客户：vaild_user）
    channel?: string;
    /**
     * SMS 群发受众统计需要透传模块标识，后端据此追加短信号码过滤。
     */
    module?: 'message_broadcast' | 'message_broadcast_sms';
    country?: string;
    city?: string;
    language?: string;
    is_online?: 0 | 1;
    /**
     * 联系人创建时间范围，字段名与群发受众筛选条件保持一致。
     */
    created_time?: string;
    query?: string; // 复合查询结构 [{"field":"phone","condition":"empty","value":""}]
    data_type: 'message' | 'email';
    label_ids: string;
    update_label_ids: string;
    exclude_chat_user_ids: string;
}

export interface ContactCountRes {
    messenger_total: string;
    total: string;
    /**
     * SMS 渠道可触达客户数。
     */
    sms_total: string;
    whatsapp_total: string;
    line_total: string;
    whatsapp_platform_total: string;
    email_total: string;
}

/**
 * 获取联系人数量（群发消息使用）
 */
export const getContactCount = (params: ContactCountParams) => axios.request<Response<ContactCountRes>>({
    url: '/chat/chat-user/get-contact-count',
    method: 'post',
    data: params,
    // mock: true,
});

export interface ContactReportRes {
    uv: string; // 有效用户数
    chat_uv: string; // 有消息用户数
    order_uv: string; // 下单用户数
    unorder_uv: string; // 无下单用户数
    uv_up: string; // 有效用户数增量
    chat_uv_up: string; // 有消息用户数增量
    order_uv_up: string; // 下单用户数增量
    unorder_uv_up: string; // 无下单用户数增量
    update_time: string; // 更新时间
}

/**
 * 获取客户报表
 */
export const getContactReport = () => axios.request<Response<ContactReportRes>>({
    url: '/chat/chat-user/get-contact-report',
    method: 'get',
    // mock: true,
});

export interface TrackItem {
    url: string;
    time: string;
    type?: string
}

/**
 * 获取用户的浏览轨迹
 */
export const getUserTrackList = (id: string) => axios.request<Response<TrackItem[]>>({
    url: '/chat/chat-user/get-user-track-list',
    method: 'get',
    // mock: true,
    params: {
        chat_user_id: id,
    },
});

export interface GroupUserItem {
    chat_user_id: string;
    user_id: string;
    chat_group_id: string;
    name: string;
    avatar: string;
}
interface GroupUserListParams {
    chat_user_id: string;
    user_id?: string;
}
/**
 * 获取群聊用户列表
 */
export const getGroupUserList = (params: GroupUserListParams) => axios.request<Response<GroupUserItem[]>>({
    url: '/chat/chat-user/get-group-user-list',
    method: 'get',
    params,
    // mock: true,
});

interface SlackIMParams {
    user_id?: string;
    channel_id: string;
}

/**
 * 获取slack用户对应的chat_user_id
 */
export const getSlackIM = (params: SlackIMParams) => axios.request<Response<{ chat_user_id: string; }>>({
    url: '/chat/chat-user/get-slack-im',
    method: 'get',
    params,
    // mock: true,
});

type ImportParams = {
    import_type: 'file_import';
    file: File;
    label_ids: string;
    repeat_config: string;
    channel: Chat.channel;
    channel_id: string;
} | {
    import_type: 'copy_import';
    copy_data: string;
    label_ids: string;
    repeat_config: string;
    channel: Chat.channel;
    channel_id: string;
}

interface errorItem {
    line: string;
    error_code: string;
}

export interface ImportRes {
    success_count: string;
    repeat_count: string;
    error_count: string;
    error_line: Array<errorItem>;
}

/**
 * 导入用户
 * @param params
 * @returns
 */
export const importUser = (params: ImportParams) => axios.upload<Response<ImportRes>>({
    url: '/chat/chat-user/import',
    method: 'post',
    data: params,
});

interface SessionUsageRes {
    session_num: number;
    session_num_usage: number;
}
/**
 * 获取会话额度
 */
export const getSessionUsage = () => axios.request<Response<SessionUsageRes>>({
    url: '/chat/chat-user/get-session-usage',
    method: 'get',
});

/**
 * 删除联系人
 */
export const delContactList = (params: ContactCountParams) => axios.request({
    url: '/chat/chat-user/del-contact-list',
    method: 'post',
    data: params,
    // mock: true,
});

export interface PinSessionParams {
    session_id: string;
    is_pin: '1' | '0'; // 1-置顶 0-取消置顶
    session_status?: 'active' | 'inactive';
}
/**
 * 置顶会话
 */
export const pinSession = (data: PinSessionParams) => axios.request({
    url: '/chat/chat-user/pin-session',
    method: 'post',
    data,
    customTips: true,
    // mock: true,
});

export interface PhoneAreasItem {
    iso_code: string;
    area_code: string;
}
/**
 * 获取号码地区区号映射
 */
export const phoneAreas = () => axios.request<Response<PhoneAreasItem[]>>({
    url: '/chat/chat-user/phone-areas',
    method: 'get',
    // mock: true,
});

/* 会话批量操作 start */
export interface BatchSessionData {
    session_ids: string;
    type: '-1' | '1' | '2'; // 1-未分配 2-已分配 -1-机器人托管
    filter?: string;
    exclude_session_ids?: string; // 全选状态下排除的会话 id
    status?: '0' | '1'; // 托管状态
    session_status?: 'active' | 'inactive', // 活跃会话 历史会话
    assign_sys_user_ids?: string; // 重新分配会话，客服ID，逗号分割
    is_disturb?: '0' | '1'; // 0-取消免打扰 1-消息免打扰
    update_label_ids?: string; // 批量更新标签，标签id，逗号分割
    update_type?: 'append' | 'update'; // 更新标签方式，append-追加，update-覆盖
    invite_evalution?: 0 | 1; // 批量结束会话 是否发送邀评
    source_type?: string; // 后端鉴权使用
}

interface BatchEndSessionRes {
    res: string;
    total_num: string;
}

/**
 * 批量结束会话
 */
export const batchEndSession = (data: BatchSessionData) => axios.request<Response<BatchEndSessionRes>>({
    url: '/chat/chat-user/batch-end-session',
    method: 'post',
    data,
});

/**
 * 批量切换托管状态
 */
export const updateAllAutoReply = (data: BatchSessionData) => axios.request<Response<any>>({
    url: '/chat/chat-user/update-all-auto-reply',
    method: 'post',
    data,
});

/**
 * 标记未读
 */
export const batchUnreadSession = (data: BatchSessionData) => axios.request<Response<any>>({
    url: '/chat/chat-user/batch-unread-session',
    method: 'post',
    data,
});

/**
 * 批量标记已读
 * @param data
 */
export const batchReadSession = (data: BatchSessionData) => axios.request<Response<any>>({
    url: '/chat/chat-user/batch-read-session',
    method: 'post',
    data,
});

/**
 * 标记免打扰
 */
export const batchDisturbSession = (data: BatchSessionData) => axios.request<Response<any>>({
    url: '/chat/chat-user/batch-disturb-session',
    method: 'post',
    data,
});

/**
 * 批量分配会话
 */
export const batchAssignSession = (data: BatchSessionData) => axios.request<Response<any>>({
    url: '/chat/chat-user/batch-assign-session',
    method: 'post',
    data,
});

/**
 * 批量重新分配会话
 */
export const batchReAssignSession = (data: BatchSessionData) => axios.request<Response<any>>({
    url: '/chat/chat-user/batch-reassign-session',
    method: 'post',
    data,
});
/* 会话批量操作 end */

/**
 * 批量拉入黑名单
 */
export const batchBlackInfo = (data: any) => axios.request<Response<any>>({
    url: '/chat/chat-user/batch-update-black',
    method: 'post',
    data,
});

export interface BatchTagsInfo {
    chat_session_ids: string;
    tags: any;
    update_type: 'append' | 'cover',
    remark?: string;
    /** 操作日志归属模块；在线聊天使用 7，会话管理使用 8。 */
    menu_module?: UpdateUserInfoMenuModule;
}

/**
 * 批量给已结束会话更改标签
 * @param data
 */
export const batchTags = (data: BatchTagsInfo) => axios.request<Response<any>>({
    url: '/chat/chat-session-storage/batch-tags',
    method: 'post',
    data,
});

interface MessageInfoRes {
    chat_user_id: string;
    sequence_id: string;
    mid: string;
    read_time: string;
}
/**
 * 获取聊天记录详情
 */
export const getMessageInfo = (params: {
    chat_user_id: string;
    mids: string;
}) => axios.request<Response<MessageInfoRes[]>>({
    url: '/chat/chat-user/get-message-info',
    method: 'get',
    params,
    // mock: true,
});

export interface AssignedSessionCountItem {
    sys_user_id: string;
    session_count: string;
}

export const getAssignedSessionCount = (params: any) => axios.request<Response<AssignedSessionCountItem[]>>({
    url: '/chat/chat-user/get-assign-session-count',
    method: 'get',
    params,
});

export interface GroupRelationParams {
    chat_user_id: string;
    name?: string;
    phone?: string;
    join_time?: string; // {"start_time": 11111111, "end_time": 22222222}
    channel_uid?: string;
    keywords?: string;
    page?: number;
    page_size?: number;
}

// 获取群成员列表
export const getGroupRelationList = (params: GroupRelationParams) => axios.request<Response<{
    list: any[];
}>>({
    url: '/chat/chat-user/get-group-relation-list',
    method: 'get',
    params,
});
// 导出群成员列表
export const exportGroupRelationListTask = (data: any) => {
    return axios.request<Response<TaskListItem>>({
        url: '/chat/chat-user/export-group-relation-list-task',
        method: 'post',
        data,
    });
};

export const getGroupRelationCount = (params: GroupRelationParams) => axios.request<Response<{
    total: string;
}>>({
    url: '/chat/chat-user/get-group-relation-count',
    method: 'get',
    params,
});

interface SendMessageModeData {
    mode: 'http' | 'socket';
    send_message_retry: '1'| '0'; // 0 关闭，1 开启
}

/**
 * 请求发送消息类型
 */
export const getSendMessageMode = () => axios.request<Response<SendMessageModeData>>({
    url: '/chat/chat-user/get-send-message-mode',
    method: 'post',
});

export const getSocketLog = () => axios.request<Response<{ is_log: '0' | '1' | '' }>>({
    url: '/chat/chat-user/socket-log',
    method: 'get',
});

export interface SingleContactData {
    channel: '3' | '7';
    add_type?: '1' | '2'; // 1-覆盖 2-跳过
    name: string;
    phone: string;
    email: string;
    country?: string;
    labels: string;
    remark: string;
    channel_id: string;
    customer_sys_user_id: string;
}

/**
 * 创建联系人（单个添加模式）
 * @param data
 */
export const createSingleContact = (data: SingleContactData) => axios.request<Response<any>>({
    url: '/chat/chat-user-import/add',
    method: 'post',
    data,
});

interface SyncFbCustomerLabelParams {
    chat_user_id: string,
    module: 'chat_online_list' | 'contact_list' | 'session_list',
}

/**
 * 更新facebook用户标签
 * @param data
 */
export const syncFbCustomerLabel = (data: SyncFbCustomerLabelParams) => axios.request<Response<any>>({
    url: `/chat/chat-user/sync-facebook-customer-labels?chat_user_id=${data.chat_user_id}`,
    method: 'post',
    data,
});

/**
 * 客户列表导出客户资料任务-增加任务通知，目前使用
 * @param params
 */
export const exportContactListTask = (data: any) => {
    data.lang = ['zh-CN', 'zh-TW'].includes(i18n.locale) ? 'zh-CN' : (i18n.locale || 'zh-CN');
    return axios.request<Response<TaskListItem>>({
        url: 'chat/chat-user/export-contact-list-task',
        method: 'post',
        data,
    });
};

/**
 * 客户列表导出更新任务-增加任务通知，目前使用
 * @param params
 */
export const exportUpdateContactListTask = (data: any) => {
    data.lang = ['zh-CN', 'zh-TW'].includes(i18n.locale) ? 'zh-CN' : (i18n.locale || 'zh-CN');
    return axios.request<Response<TaskListItem>>({
        url: 'chat/chat-user/export-update-contact-list-task',
        method: 'post',
        data,
    });
};

type BatchAssignType = {
    assign_sys_user_id: string;
    action: 'start' | 'cancel'; // 操作行为：start：开始  cancel：取消
    project_id: string;
    exclude_chat_user_ids?: string;
    ids?: string;
    is_group_auth: '1';
    type: string;
    query?: string;
    task_id?: string; // 用于取消
    advanced_query_type?: string;
    advanced_query?: string;
    search_type?: '0' | '1', // 搜索条件类型 0-默认 1-自定义字段
}

/**
 * 客户列表分配客户
 * @param {BatchAssignType} data
 * @returns {string} task_id
 */
export const batchAssignByContactList = (data: BatchAssignType) => axios.request<Response<{task_id: string}>>({
    url: '/chat/chat-user/batch-assign-chat-user-v1',
    method: 'post',
    data,
});

export interface GetSimilarContactListParams {
    page_size: number;
    page: number;
    email?: string;
    phone?: string;
    channel: Chat.channel;
    chat_user_id: string;
    search_type?: '0' | '1' | '2'; // 0: 全部  1: 已关联  2: 未关联
}

export interface ContactItem {
    channel: string;
    name: string;
    remark_name: string;
    email: string;
    phone: string;
    country: string;
    city: string;
    language: string;
    labels: {
        id: string;
        label_name: string;
    }[] | string;
    is_online: string;
    remark: string;
    created_time: string;
    channel_id: string;
    channel_uid: string;
    order_cnt: string;
    order_amount: string;
    msg_cnt: string;
    session_cnt: string;
    msg_last_send_time: string;
    user_last_reply_time: string;
    sys_user_id: string;
    chat_type: string;
    translate_language: string;
    tg_user_name: string;
    chat_user_id: string;
    sys_user_name: string;
    channel_phone: string;
    channel_name: string;
    avatar?: string;
    is_auth: string;
    similar_phone: string;
    is_correlation: '0' | '1'; // 0.未关联 1.已关联
    connection_type: '0' | '1'; // 0.手动 1.自动
  }

  interface ContactListData {
    list: ContactItem[];
    total: string;
    search_type: '0' | '1' | '2'; // 0: 全部  1: 已关联  2: 未关联
  }

/**
 * 获取相似联系人
 * @param params
 * @returns
 */
export const getSimilarContactList = (params: GetSimilarContactListParams) => axios.request<Response<ContactListData>>({
    url: '/chat/chat-user/similar-contact-list',
    method: 'get',
    params,
});

export interface GetChatHistoryMessageListParams {
    chat_user_id: string;
    sequence_id?: string;
    end_sequence_id?: string;
    direction_type?: '1' | '2'; // 1：正向查询 ， 0：逆向查询，默认0
    type: '1' | '2' | '3'; // 1：视频、图片  2：附件， 默认1
    page_size: number;
}

export interface HistoryMsgItem {
    sequence_id: string;
    mid: string;
    send_time: string;
    msg_type: string;
    url: string;
    file_type: string;
    caption: string;
    sender_type: string;
    sender_name: string;
    auto_type: string;
    sender: string;
    sender_avatar: string;
    content: string;
    sys_user_deleted: '0' | '1';
    /** 附件消息的自动化或工作流来源信息，version=1 时按工作流展示。 */
    auto_info?: Chat.MessageContentAutoInfo;

    // oss 刷新后定义的url
    sign_url?: string;
}

export interface Nextpk {
    chat_user_id: string;
    sequence_id: string;
  }

interface GetChatHistoryMessageListDate {
    list: HistoryMsgItem[];
    page: number;
    page_size: number;
    next_pk: Nextpk;
    package_limit: string;
}

interface List {
  sequence_id: string;
  mid: string;
  send_time: string;
  msg_type: string;
  url: string;
  file_type: string;
  caption: string;
  sender_type: string;
  sender_name: string;
}

/**
 * 获取用户历史聊天记录
 * @param params
 * @returns
 */

export const getChatHistoryMessageList = (params: GetChatHistoryMessageListParams) => axios.request<Response<GetChatHistoryMessageListDate>>({
    url: '/chat/chat-user/get-chat-history-message-list',
    method: 'get',
    params,
});

interface GetChatHistoryMessageTextListParams {
    content: string;
    send_time: string;
    chat_user_id: string;
    page: string;
    page_size: string;
}

export interface HistoryTextMsgItem {
    sequence_id: string;
    mid: string;
    send_time: string;
    msg_type: string;
    content: string;
    sender_type: string;
    sender_avatar: string;
    sender: string;
    sender_name: string;
    auto_type: string;
    sys_user_deleted?: '0' | '1';
}

interface HistoryTextMsgData {
    list: HistoryMsgItem[];
    page: number;
    page_size: number;
    total: number;
    package_limit: string;
}

/**
 * 获取历史文字消息
 * @param params
 * @returns
 */
export const getChatHistoryMessageTextList = (params: GetChatHistoryMessageTextListParams) => axios.request<Response<HistoryTextMsgData>>({
    url: '/chat/chat-user/get-chat-history-message-text-list',
    method: 'get',
    params,
});

export interface PinMessageItem extends Chat.MessageItem {
    channel_config: {
        id: string;
        name: string;
        phone_number: string;
    };
    is_system: '0' | '1';
    author: string;
    pin_time: string;
    sys_user_name: string;
}

/**
 * 获取置顶消息列表
 * @param params
 * @returns
 */
export const getPinMessageList = (params: { chat_user_id: string }) => axios.request<Response<{ list: PinMessageItem[] }>>({
    url: '/chat/chat-user/get-pin-message-list',
    method: 'get',
    params,
});

interface ConnectChatUserData {
    first_chat_user_id: string;
    second_chat_user_id: string;
    /** 操作日志归属模块；在线聊天使用 7，会话管理使用 8。 */
    menu_module?: UpdateUserInfoMenuModule;
}

/**
 * 关联联系人
 * @param data
 * @returns
 */

export const connectChatUser = (data: ConnectChatUserData) => axios.request({
    url: '/chat/chat-user/connect-chat-user',
    method: 'post',
    data,
});

interface CancelConnectChatUserData {
    chat_user_id: string;
    first_chat_user_id: string;
    /** 操作日志归属模块；在线聊天使用 7，会话管理使用 8。 */
    menu_module?: UpdateUserInfoMenuModule;
}

/**
 * 取消关联联系人
 * @param data
 * @returns
 */

export const cancelConnectChatUser = (data: CancelConnectChatUserData) => axios.request({
    url: '/chat/chat-user/cancel-connect-chat-user',
    method: 'post',
    data,
});

export interface UploadCustomAudienceData {
    adaccount_id?: string;
    audience_name?: string;
    description?: string;
    chat_user_list_version?: string;
    page_id?: string;
    audience_type: '0' | '1'; // 受众类型 0-广告受众 1-营销受众
    module: 'contact_list' | 'external_contact'; // contact_list-联系人列表 external_contact-外部导入
    file_url?: string; // 外部导入url
    audience_id?: string; // 受众包id
}

/**
 * 上传fb自定义受众
 * @param data
 * @returns
 */

export const uploadCustomAudience = (data: UploadCustomAudienceData) => axios.request<Response<any>>({
    url: '/chat/chat-user/upload-fb-custom-audience',
    method: 'post',
    data,
    customTips: true,
});
export interface VisitorTags {
    title: string;
    labels?: any[];
    channel?: string;
    channelId?: string;
    loading?: boolean;
    isShowFbTag?: boolean;
    contactTotal?: any;
    operationType?: 'select' | 'filterSelect' | 'batchSelect';
}

/**
 * 在线聊天批量打标签-任务中心
 */
export const batchChatUpdateLabelTask = (params: BatchSessionData) => axios.request<Response<TaskListItem>>({
    url: '/chat/chat-user/chat-batch-update-label',
    method: 'post',
    data: params,
});

/**
 * 客户列表批量打标签-任务中心
 */
export const batchUpdateLabelTask = (params: any) => axios.request<Response<TaskListItem>>({
    url: '/chat/chat-user/batch-update-label-task',
    method: 'post',
    data: params,
});

interface GetGroupUserInfo {
    chat_group_id: string;
    channel_uid?: string;
}

interface GroupUserInfo {
    list: {
        chat_group_id: string;
        channel_uid: string;
        name: string;
        avatar: string;
        phone: string;
        role_type: string;
        chat_user_id: string;
        labels: string;
        remark: string;
    }
}

/**
 * 获取群成员信息
 * @param params
 * @returns
 */

export const getGroupUserInfo = (params: GetGroupUserInfo) => axios.request<Response<GroupUserInfo>>({
    url: '/chat/chat-user/get-group-member-info',
    method: 'get',
    params,
});

interface ExpressionListParams {
    page: number;
    page_size: number;
}

/**
 * 获取表情包列表
 * @param params
 * @returns
 */
export const getExpressionList = (params: ExpressionListParams) => axios.request<Response<any>>({
    url: '/chat/chat-user/get-expression-list',
    method: 'get',
    params,
});

export interface ExpressionItem {
    temp_id?: string;
    id?: string;
    file_name: string; // 文件名称
    // format: string; // 类型
    // size: string; // 大小（字节）
    url: string; // URL地址
    // created_time?:
}

/**
 * 新增表情包
 * @param data
 * @returns
 */
export const addExpressionItem = (data: ExpressionItem[]) => axios.request<Response<ExpressionItem[]>>({
    url: '/chat/chat-user/add-expression',
    method: 'post',
    data: {
        expression_info: JSON.stringify(data),
    },
});

/**
 * 删除表情包
 * @param params
 * @returns
 */
export const deleteExpressionItem = (data: { expression_id: string }) => axios.request<Response<any>>({
    url: '/chat/chat-user/del-expression',
    method: 'post',
    data,
});

interface LocationParams {
    mid: string; // 消息MID
    channel: Chat.channel; // 渠道
    chat_user_id: string;
    is_quote: '0' | '1'; // 是否引用消息
}

/**
 * 获取历史位置消息地图
 * @param params
 * @returns
 */
export const getChatMapImage = (data: LocationParams) => axios.request<Response<{ mid: string; location_url: string; }>>({
    url: '/chat/chat-user/history-msg-map',
    method: 'post',
    data,
    customTips: true,
});

/** 删除联系人接口参数。 */
interface DelContactParams {
    channel: Chat.channel;
    chat_user_id: string;
    /** 操作日志归属模块；在线聊天使用 7，会话管理使用 8。 */
    menu_module?: UpdateUserInfoMenuModule;
}

/**
 * 更新用户信息
 */
export const delContact = (params: DelContactParams) => axios.request({
    url: '/chat/chat-user/del-contact',
    method: 'post',
    data: params,
});

interface GetUrlPreviewData {
    chat_user_id: string;
    sequence_id: string;
    url: string;
}
/**
 * 获取消息链接预览
 */
export const getUrlPreview = (data: GetUrlPreviewData) => axios.request<Response<GetUrlPreviewData & { og: Chat.ContentOg }>>({
    url: '/chat/chat-user/get-url-preview',
    method: 'post',
    data,
    customTips: true,
});

interface ChatUserInfoParams {
    chat_user_id: string;
    channel_id: string;
    channel: string;
}

/**
 * 用户手动触发更新客户资料
 * @param params
 */
export const updateChatUserInfo = (params: ChatUserInfoParams) => axios.request<Response<any>>({
    url: 'chat/chat-user/update-chat-user-info',
    method: 'get',
    params,
});
